module.exports = __webpack_public_path__ + "media/images/trash-0f35a49db2ab92bac03576f78ad8c3c8.svg";